import React from 'react';
import { Typography } from '@mui/material';
import { PIPE } from '@assetron/common/constants/constant';
import AssetronButton from './AssetronButton';
import useErrorMessageStyles from './styles/useErrorMessageStyles';

interface ErrorMessageProps {
  message: string;
  isHavingPipe?: boolean;
  linkText?: string;
  onLinkClick?: unknown;
}

function ErrorMessage({
  message,
  isHavingPipe,
  linkText,
  onLinkClick,
}: Readonly<ErrorMessageProps>) {
  const styles = useErrorMessageStyles();

  return (
    <>
      <Typography variant="body_12_regular" sx={styles.errorMessage}>
        {message}
      </Typography>
      {isHavingPipe && (
        <Typography variant="body_12_regular" sx={styles.pipe}>
          {PIPE}
        </Typography>
      )}
      {linkText && (
        <AssetronButton hierarchy="link">
          <Typography
            variant="body_12_regular"
            sx={styles.linkText}
            onClick={onLinkClick}
            data-testid="error-message-link"
          >
            {linkText}
          </Typography>
        </AssetronButton>
      )}
    </>
  );
}

export default ErrorMessage;
